import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DashDialog.css";

export default function DashDialog({ title, children, onClose, submitLabel = "حفظ", onSubmit, submitDisabled = false }) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) onClose();
    else navigate(-1);
  };

  /* lock body scroll while dialog is open */
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  /* close on Escape key */
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") handleClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  return (
    <div className="dialog-overlay" onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}>
      <div className="dialog-panel" role="dialog" aria-modal="true">
        {/* Header */}
        <div className="dialog-header">
          <h2 className="dialog-title">{title}</h2>
          <button className="dialog-close" onClick={handleClose} aria-label="إغلاق">✕</button>
        </div>

        {/* Body */}
        <div className="dialog-body">
          {children}
        </div>

        {/* Footer */}
        <div className="dialog-footer">
          <button type="button" className="dialog-cancel-btn" onClick={handleClose}>
            إلغاء
          </button>
          <button
            type="button"
            className="dialog-submit-btn"
            disabled={submitDisabled}
            onClick={onSubmit}
          >
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
            </svg>
            {submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
